module.exports = __webpack_public_path__ + "img/p2-p3-diaoxiang.2821fb2e.png";